<template>
	<div class="award">
		<div class="award__table award__list">
			<table class="simple-table">
				<thead>
					<tr>
						<th class="award__list__num">항번</th>
						<th class="award__list__name">2차카테고리명</th>
						<th class="award__list__sort">정렬순서</th>
						<th class="award__list__btn">수정</th>
						<th class="award__list__btn">삭제</th>
						<th class="award__list__categoryNum">
							하위카테고리갯수
						</th>
						<th class="award__list__btn">3차 이동</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(second, idx) in secondCategoryList"
						:key="second.idHitCategory"
					>
						<td class="award__list__num">
							{{ second.idHitCategory }}
						</td>
						<td class="award__list__name">
							<input
								v-model="second.categoryText"
								@input="getSecondCategory(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__sort">
							<input
								v-model="second.sortKey"
								@input="getSortKey(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__btn">
							<button
								@click="modifySecondCategory(idx)"
								class="btn orange"
							>
								수정
							</button>
						</td>
						<td class="award__list__btn">
							<button
								@click="deleteSecondCategory(idx)"
								class="btn gray"
								:disabled="!!second.childrenCount"
							>
								삭제
							</button>
						</td>
						<td class="award__list__categoryNum">
							{{ second.childrenCount }}개
						</td>
						<td class="award__list__btn">
							<button
								class="btn mint"
								@click="moveThirdCategory(idx)"
							>
								이동
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import debounce from 'lodash/debounce';
	import { mapState } from 'vuex';

	export default {
		name: 'AwardSecondCategory',
		data() {
			return {
				categoryNameList: [],
				categorySortList: [],
				idHitProduct: this.$route.query.idHitProduct,
			};
		},
		props: {
			awardId: {
				default: 0,
			},
		},
		watch: {
			secondCategoryList() {
				this.secondCategoryList.forEach((item, idx) => {
					this.categoryNameList[idx] = item.categoryText;
					this.categorySortList[idx] = item.sortKey;
				});
			},
		},
		computed: {
			...mapState('award', ['secondCategoryList']),
		},

		methods: {
			getSecondCategory: _.debounce(async function (index, event) {
				this.categoryNameList[index] = event.target.value;
			}, 500),

			getSortKey: _.debounce(async function (index, event) {
				this.categorySortList[index] = event.target.value;
			}, 500),

			async getList() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getSecondCategory', {
					idHitProduct,
					idHitCategory,
				});
			},
			async modifySecondCategory(index) {
				if (!confirm('정말 수정하시겠습니까?')) return;
				try {
					const number = this.secondCategoryList[index].idHitCategory;
					const params = {
						categoryText: this.categoryNameList[index],
						sortKey: this.categorySortList[index],
					};
					await this.$axiosAdmin2.put(
						`/api/award/secondcategory/${this.awardId}/${number}`,
						params
					);
					alert('수정되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'수정 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			async deleteSecondCategory(index) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					const number = this.secondCategoryList[index].idHitCategory;
					await this.$axiosAdmin2.delete(
						`/api/award/secondcategory/${this.awardId}/${number}`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'삭제 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},

			moveThirdCategory(index) {
				const number = this.secondCategoryList[index].idHitCategory;
				this.$router.push(
					`/product/manage-awards/thirdCategory?idHitProduct=${this.awardId}&idHitCategory=${number}`
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.award {
		&__table {
			margin-top: 20px;
			.simple-table {
				th {
					text-align: center;
					padding: 0;
				}
			}
		}

		&__list {
			margin-top: 70px;
			&__btn {
				width: 30px;
				text-align: center;
				button {
					&:disabled {
						border: none;
					}
				}
			}
			&__num {
				width: 30px;
				text-align: center;
			}
			&__name {
				width: 300px;
			}
			&__sort {
				width: 70px;
			}
			&__categoryNum {
				width: 100px;
				text-align: center;
			}
		}
	}
</style>
